import { isEmpty, type DashboardWidget, type TabularResult } from '@terros/common'
import { toReportGroupEntity, type ReportGroupEntity } from '@front/model'

export type LeaderboardRow = {
  entity: ReportGroupEntity
  value: number | null
}

export function toLeaderboardRows({
  data,
  metricIndex,
  widget,
}: {
  data: TabularResult
  metricIndex: number
  widget: Extract<DashboardWidget, { type: 'leaderboard' }>
}): LeaderboardRow[] {
  if (isEmpty(data.rows)) return []

  const multiplier = widget.direction === 'asc' ? 1 : -1

  return data.rows
    .map((row): LeaderboardRow | undefined => {
      const entity = toReportGroupEntity(row[0])
      if (!entity) return undefined

      const value = row[metricIndex + 1]
      return { entity, value: typeof value === 'number' ? value : null }
    })
    .filter((row): row is LeaderboardRow => row !== undefined)
    .sort((a, b) => sortLeaderboardValues(a.value, b.value, multiplier))
}

function sortLeaderboardValues(a: number | null, b: number | null, multiplier: number): number {
  if (a === null && b === null) return 0
  if (a === null) return 1
  if (b === null) return -1
  return (a - b) * multiplier
}
